export default __webpack_public_path__ + "8fa48c14f28ac3eda3663a04ee2d54cc.fig";